import { doConfirmCurrentUser } from 'ducks/currentUser/operations'
import { mapErrorsToFormFields } from 'api/graphql'
import { V2_COMPLETION_PAGE } from '../pages'

export function doSaveAndRedirect({ confirmationToken }) {
  return dispatch => {
    return dispatch(doConfirmCurrentUser(confirmationToken))
      .then(() => {
        dispatch({
          type: V2_COMPLETION_PAGE,
        })
      })
      .catch(mapErrorsToFormFields)
  }
}
